import { ROAD } from '../constants';
import { mapy } from './mapy';

// pick random number for road and return it and the road cost
function pickNumberAndCost() {
  const first_digit = 1 + Math.floor(Math.random() * 10);
  const second_digit = Math.floor(Math.random() * 8);
  const number = first_digit * 10 + second_digit;
  let cost = 0;
  // see if fits then change to this
  // cost = mapy[number][0] + mapy[number][1] + mapy[number][2];
  if (second_digit < 3) cost = 75;
  else if (second_digit < 6) cost = 150;
  else if (second_digit < 9) cost = 300;
  return [number, cost];
}

function goesOn(numberOfSRoadBlocks: number) {
  if (Math.random() < 1 / numberOfSRoadBlocks) return false;
  else return true;
}

function pickNumberEnd() {
  return 200 + Math.floor(Math.random() * 2) * 10 + Math.floor(Math.random() * 8);
}

function isTooTwisty(number: number) {
  // check if the map[number] is to twisty
  const PARAMS = (mapy as any)[number];
  const ENTRANCE = PARAMS[0];
  const HOLD = PARAMS[1];
  const EXIT = PARAMS[2];
  const CURVE = PARAMS[3];
  // const HILL = PARAMS[4];
  // any road with curve hard
  if (CURVE >= ROAD.CURVE.HARD) return true;
  // small roads with curve medium
  if (ENTRANCE + HOLD + EXIT <= ROAD.LENGTH.SHORT * 2 + ROAD.LENGTH.MEDIUM && CURVE >= ROAD.CURVE.MEDIUM) return true;
  return false;
}

export function createStraight(minLength: number, maxLength: number) {
  let road: Array<number> = [];
  let roadLength: number = 0;
  while (roadLength < minLength) {
    let road_block = pickNumberAndCost();
    if (isTooTwisty(road_block[0]) == false) {
      road.push(road_block[0]);
      roadLength += road_block[1];
      // console.log(roadLength, road_block[0], isToTwisty(road_block[0]));
    }
  }

  let goOn = true;
  while (roadLength < maxLength && goOn == true) {
    goOn = goesOn(8);
    if (goOn === true) {
      let road_block = pickNumberAndCost();
      if (roadLength + road_block[1] > maxLength) goOn = false;
      else if (isTooTwisty(road_block[0]) == false) {
        road.push(road_block[0]);
        roadLength += road_block[1];
      }
    }
  }
  return {
    road,
    roadLength,
  };
}

// type ICreateTwisty =  Array<number>, number;

export function createTwisty(minLength: number, maxLength: number) {
  let road: Array<number> = [];
  let roadLength: number = 0;
  while (roadLength < minLength) {
    let road_block = pickNumberAndCost();
    road.push(road_block[0]);
    roadLength += road_block[1];
    // console.log(roadLength, road_block[0], isToTwisty(road_block[0]));
  }

  let goOn = true;
  while (roadLength < maxLength && goOn == true) {
    goOn = goesOn(8);
    if (goOn === true) {
      let road_block = pickNumberAndCost();

      if (roadLength + road_block[1] > maxLength) goOn = false;
      else {
        road.push(road_block[0]);
        roadLength += road_block[1];
      }
    }
  }
  return {
    road,
    roadLength,
  };
}

export function getNumberOfCarsForLength(minLength: number, traffic: string, length: any) {
  let baseNumber = 0;
  switch (traffic) {
    case 'low':
      baseNumber = 170;
      break;
    case 'usual':
      baseNumber = 200;
      break;
    case 'intense':
      baseNumber = 230;
      break;
    default:
      console.error('invalid cars amount selected');
      break;
  }
  let roadUsedForMaths = length;
  roadUsedForMaths -= minLength;
  let randomNumber = Math.random() * 19 - 10;
  //  console.log('roadUsedForMaths: ', roadUsedForMaths/40, randomNumber);

  let extraCars = roadUsedForMaths / 40 + randomNumber;
  return Math.floor(baseNumber + extraCars);
}
